import React from 'react';
import { format } from 'date-fns';

export const AccountInfoCard = ({ account }) => (
  <div className="bg-surface border border-border rounded-lg p-4" data-testid="account-info-card">
    <h2 className="text-lg font-heading font-semibold text-text-primary mb-4">Account Info</h2>
    <dl className="space-y-3 text-sm">
      <div>
        <dt className="text-text-secondary">Received Date</dt>
        <dd className="text-text-primary">{format(new Date(account.account_received_date), 'MMM d, yyyy')}</dd>
      </div>
      <div>
        <dt className="text-text-secondary">Created By</dt>
        <dd className="text-text-primary">{account.created_by_name}</dd>
      </div>
      <div>
        <dt className="text-text-secondary">Last Activity</dt>
        <dd className="text-text-primary">{format(new Date(account.last_activity_date), 'MMM d, yyyy h:mm a')}</dd>
      </div>
    </dl>
  </div>
);

export const ActivityLog = ({ activityLog }) => (
  <div className="bg-surface border border-border rounded-lg p-4" data-testid="activity-log">
    <h2 className="text-lg font-heading font-semibold text-text-primary mb-4">Activity Log</h2>
    <div className="space-y-3 max-h-[500px] overflow-y-auto">
      {activityLog.slice().reverse().map((entry) => (
        <div key={`${entry.timestamp}-${entry.action}`} className="flex gap-3 text-sm">
          <div className="w-2 h-2 mt-1.5 rounded-full bg-primary flex-shrink-0" />
          <div>
            <p className="text-text-primary">{entry.action}</p>
            {entry.details && <p className="text-text-secondary text-xs">{entry.details}</p>}
            <p className="text-text-secondary text-xs mt-1">
              {entry.user_name} - {format(new Date(entry.timestamp), 'MMM d, h:mm a')}
            </p>
          </div>
        </div>
      ))}
    </div>
  </div>
);
